import { schema } from "@anna-money/anna-web-lib/serializer";
import { genericObject } from "helpers/serialization";

export class LeadCreateData extends schema(
  {
    lead: genericObject(),
  },
  "LeadCreateData",
) {}
